import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { ShowLocationComponent } from './terms/show-location/show-location.component';
import { ShowMarketingComponent } from './terms/show-marketing/show-marketing.component';
import { ShowPrivacyComponent } from './terms/show-privacy/show-privacy.component';
import { ShowServiceComponent } from './terms/show-service/show-service.component';
import { ShowWayComponent } from './terms/show-way/show-way.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'service',
    component: ShowServiceComponent,
    loadChildren: () => import('../app/terms/terms.module').then(m => m.TermsModule),
  },
  {
    path: 'privacy',
    component: ShowPrivacyComponent,
    loadChildren: () => import('../app/terms/terms.module').then(m => m.TermsModule),
  },
  {
    path: 'location',
    component: ShowLocationComponent,
    loadChildren: () => import('../app/terms/terms.module').then(m => m.TermsModule),
  },
  {
    path: 'marketing',
    component: ShowMarketingComponent,
    loadChildren: () => import('../app/terms/terms.module').then(m => m.TermsModule),
  },
  {
    path: 'way',
    component: ShowWayComponent,
    loadChildren: () => import('../app/terms/terms.module').then(m => m.TermsModule),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
